export default __webpack_public_path__ + "static/media/select-polygon.1c9862c4.png";